module.exports = "<div class=\"panel simple\">\n\t<div class=\"panel-title\">\n\t\t<h3>Użytkownicy</h3>\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<data-table [columns]=\"columns\" [rows]=\"users\" [buttons]=\"actions\" [isLoading]=\"isLoading\"\n\t\t            [pager]=\"pager\" (tableChanged)=\"tableChanged($event)\"></data-table>\n\n\n\t\t<user-modal #userModal (refreshList)=\"refreshList($event)\"></user-modal>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/users/users.component.html
// module id = ../../../../../src/app/main/users/users.component.html
// module chunks = 1